<article
  [attr.role]="interactive ? 'button' : null"
  [attr.tabindex]="interactive ? 0 : null"
  [attr.aria-label]="interactive && cardLabel ? cardLabel : null"
  [class.cursor-pointer]="interactive"
  (click)="onActivate()"
  (keydown.enter)="onActivate()"
  (keydown.space)="onActivate(); $event.preventDefault()"
  class="rounded-xl border border-neutral-gray30 bg-neutral-white p-4 shadow-sm transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-90">
  <div class="flex items-start justify-between gap-3">
    <div class="min-w-0 flex-1 text-base font-medium text-neutral-gray70">
      <ng-content select="[cardTitle]"></ng-content>
    </div>
    <div class="shrink-0">
      <ng-content select="[cardBadge]"></ng-content>
    </div>
  </div>

  <div class="mt-3 flex flex-col gap-2">
    <ng-content select="app-stacked-card-field"></ng-content>
  </div>

  <ng-content select="[cardActions]"></ng-content>
</article>
